module.exports = __webpack_public_path__ + "static/media/checkmark-sm-dark.8e756fa4.svg";